import { Add, Search } from "@mui/icons-material";
import { Box, Button, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

interface IKeyDriveSearchBarWithButton {
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onClick: () => void;
    btnText: string;
    disabledButton?: boolean;
}

export const KeyDriveSearchBarWithButton : React.FC<IKeyDriveSearchBarWithButton> = ({onChange,btnText,onClick,disabledButton}) => {

    const {t} = useTranslation();

    return (
        <Box sx={{
            height: '36px',
            display: 'flex',
            gap: '20px',
            padding: '0px',
        }}>
            <TextField
                fullWidth
                id="filled-basic"
                variant="filled"
                placeholder={t('AdminConsole.WhatAreYouLookingFor')}
                onChange={onChange}
                InputProps={{
                    disableUnderline: true,
                    startAdornment: (
                        <Box sx={{ display: 'flex', alignItems: 'center', paddingRight: '10px', opacity: '0.5' }}>
                            <Search />
                        </Box>
                    ),
                    sx: {
                        height: '36px',
                        padding: '0 10px',
                        '& .MuiFilledInput-input': {
                            height: '36px',
                            padding: '0 10px',
                            display: 'flex',
                            alignItems: 'center',
                        },
                    },
                }}
                sx={{
                    '& .MuiInputBase-root': {
                        height: '36px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px',
                    },
                    '& input::placeholder': {
                        fontSize: '14px',
                        color: '#969696',
                    },
                }}
            />
            <Button
                variant="contained"
                startIcon={<Add />}
                sx={{
                    height: '36px',
                    backgroundColor: '#22638D',
                    textTransform: 'none',
                    font: 'normal normal normal 14px/21px Segoe UI',
                    whiteSpace: 'nowrap'
                }}
                onClick={onClick}
                disabled={disabledButton}
            >
                {btnText}
            </Button>
        </Box>
    )
}